import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";

export default function AdminCoupons() {
  const [coupons, setCoupons] = useState([]);
  const [form, setForm] = useState({ code: "", type: "percent", value: 10, min_amount: 0, active: true });

  const load = async () => { const { data } = await api.get("/admin/coupons"); setCoupons(data); };
  useEffect(() => { load(); }, []);

  const create = async () => {
    try {
      await api.post("/admin/coupons", { ...form, value: parseFloat(form.value), min_amount: parseFloat(form.min_amount || 0) });
      toast.success("Cupón creado");
      setForm({ code: "", type: "percent", value: 10, min_amount: 0, active: true });
      load();
    } catch (e) { toast.error(e.response?.data?.detail || "Error"); }
  };
  const remove = async (id) => { await api.delete(`/admin/coupons/${id}`); load(); };

  return (
    <div data-testid="admin-coupons-page">
      <h1 className="font-serif text-5xl tracking-tighter">Cupones</h1>
      <p className="text-[#5B605E] mt-1">Gestiona descuentos y promociones.</p>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mt-8">
        <div className="bg-white border border-[#E8E3DA] p-6 lg:col-span-1">
          <h2 className="font-serif text-2xl mb-4">Nuevo cupón</h2>
          <div className="space-y-3">
            <input className="w-full border border-[#2C302E] bg-transparent px-3 py-2" placeholder="CÓDIGO" value={form.code} onChange={(e) => setForm({ ...form, code: e.target.value.toUpperCase() })} data-testid="cp-code" />
            <select className="w-full border border-[#2C302E] bg-transparent px-3 py-2" value={form.type} onChange={(e) => setForm({ ...form, type: e.target.value })}>
              <option value="percent">Porcentaje (%)</option>
              <option value="fixed">Monto fijo (MXN)</option>
            </select>
            <input type="number" className="w-full border border-[#2C302E] bg-transparent px-3 py-2" placeholder="Valor" value={form.value} onChange={(e) => setForm({ ...form, value: e.target.value })} />
            <input type="number" className="w-full border border-[#2C302E] bg-transparent px-3 py-2" placeholder="Compra mínima" value={form.min_amount} onChange={(e) => setForm({ ...form, min_amount: e.target.value })} />
            <button onClick={create} className="btn-primary w-full" data-testid="cp-save">Crear</button>
          </div>
        </div>

        <div className="lg:col-span-2 bg-white border border-[#E8E3DA]">
          <table className="w-full text-sm">
            <thead className="bg-[#F2EFE9] text-left text-[10px] uppercase tracking-wider">
              <tr><th className="px-4 py-3">Código</th><th>Tipo</th><th>Valor</th><th>Mín.</th><th></th></tr>
            </thead>
            <tbody>
              {coupons.map((c) => (
                <tr key={c.id} className="border-t border-[#E8E3DA]">
                  <td className="px-4 py-3 font-mono">{c.code}</td>
                  <td>{c.type}</td>
                  <td>{c.type === "percent" ? `${c.value}%` : `$${c.value}`}</td>
                  <td>${c.min_amount || 0}</td>
                  <td className="text-right pr-4"><button onClick={() => remove(c.id)} className="hover:text-[#9E2A2B]"><Trash2 size={14} /></button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
